import { render, staticRenderFns } from "./UserRole.vue?vue&type=template&id=0266fa9c&scoped=true&"
import script from "./UserRole.vue?vue&type=script&lang=js&"
export * from "./UserRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0266fa9c",
  null
  
)

export default component.exports